import {browserName, fullBrowserVersion, mobileModel, mobileVendor, osName, osVersion} from 'mobile-device-detect';
import {LogParameter, LogMessageApi} from '../../build/swagger-code-commons-api-definition/api';

type LogMessageConstructor = Omit<LogParameter, 'userAgent'>;

export default class LogMessage {
    private static readonly NO_DEVICE_DETECTED: string = 'none';
    private static readonly DEFAULT_URL = window.location.href;
    private static readonly USER_AGENT = LogMessage.indentifyBrowser();
    private static readonly LOG_MESSAGE_API = new LogMessageApi({basePath: process.env.VUE_APP_CONTEXT_BASE});

    private static indentifyBrowser(): string {
        let userAgent = '';
        if (mobileVendor !== this.NO_DEVICE_DETECTED && mobileModel !== this.NO_DEVICE_DETECTED) {
            userAgent += mobileVendor + ' ' + mobileModel + ': ';
        }
        if (osName !== this.NO_DEVICE_DETECTED && osVersion !== this.NO_DEVICE_DETECTED) {
            userAgent += osName + ' ' + osVersion + ', ';
        }
        if (browserName !== this.NO_DEVICE_DETECTED && fullBrowserVersion !== this.NO_DEVICE_DETECTED) {
            userAgent += browserName + ' ' + fullBrowserVersion;
        }
        return userAgent;
    }

    private parameters: LogParameter = {};

    constructor({error, url}: LogMessageConstructor = {}) {
        this.parameters.error = error || '';
        this.parameters.url = url || LogMessage.DEFAULT_URL;
        this.parameters.userAgent = LogMessage.USER_AGENT;
    }

    public setErrorMessage(errorMessage: string): LogMessage {
        this.parameters.error = errorMessage;
        this.parameters.url = LogMessage.DEFAULT_URL;
        return this;
    }

    public setUrl(url: string): LogMessage {
        this.parameters.url = url;
        return this;
    }

    public send() {
        if (this.parameters.error !== '') {
            return LogMessage.LOG_MESSAGE_API.postLogMessage(this.parameters, {credentials: 'same-origin'});
        }
    }
}
